import { Flex, Box } from '@chakra-ui/layout'
import { FC } from 'react'
import ContentLoader from 'react-content-loader'

const OverviewLoading: FC<{ isLoaded: boolean }> = ({ isLoaded, children }) => {
  if (isLoaded) {
    return <>{children}</>
  }

  return (
    <Flex alignItems="center" justifyContent="center" h="336px">
      <Box ml="64px" mt="-120px">
        <ContentLoader width={300} height={300} viewBox="0 0 200 200">
          <rect x="0" y="160" rx="0" ry="0" width="25" height="40" />
          <rect x="30" y="145" rx="0" ry="0" width="25" height="55" />
          <rect x="60" y="126" rx="0" ry="0" width="25" height="74" />
          <rect x="90" y="80" rx="0" ry="0" width="25" height="200" />
          <rect x="120" y="142" rx="0" ry="0" width="25" height="58" />
        </ContentLoader>
      </Box>
    </Flex>
  )
}

export default OverviewLoading
